module.exports = __webpack_public_path__ + "img/swap.cbc897e3.svg";